export default __webpack_public_path__ + "static/media/aerofoam.4077db6d.jpeg";